"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderImageAlignment = exports.BackgroundType = exports.GatewayType = exports.ProcessorType = exports.PaymentType = exports.DonationDedicationType = exports.ApiGateway = void 0;
var Axios = require("axios");
//export namespace BigBrain.GivingPortal.Gateways.ScriptTS {
var ApiGateway = /** @class */ (function () {
    function ApiGateway() {
    }
    ApiGateway.GetGivingOptions = function () {
        var url = ApiGateway.RouteGetGivingOptions();
        return ApiGateway.MakeRequestGeneric(null, url, 'get');
    };
    ApiGateway.GetDisplayCanadianSpelling = function () {
        var url = ApiGateway.RouteGetDisplayCanadianSpelling();
        return ApiGateway.MakeRequestGeneric(null, url, 'get');
    };
    ApiGateway.PaymentMethod = function () {
        var url = ApiGateway.RoutePaymentMethod();
        return ApiGateway.MakeRequestGeneric(null, url, 'get');
    };
    ApiGateway.PaymentPublicToken = function (paymentMethodId) {
        var url = ApiGateway.RoutePaymentPublicToken(paymentMethodId);
        return ApiGateway.MakeRequestGeneric(null, url, 'get');
    };
    ApiGateway.GetBusinessUnitHasCCPaymentMethods = function () {
        var url = ApiGateway.RouteGetBusinessUnitHasCCPaymentMethods();
        return ApiGateway.MakeRequestGeneric(null, url, 'get');
    };
    ApiGateway.GetSiteInfo = function () {
        var url = ApiGateway.RouteGetSiteInfo();
        return ApiGateway.MakeRequestGeneric(null, url, 'get');
    };
    ApiGateway.SubmitDonation = function (dto) {
        var url = ApiGateway.RouteSubmitDonation();
        return ApiGateway.MakeRequestGeneric(dto, url, 'post');
    };
    ApiGateway.MakeRequestGeneric = function (data, url, method) {
        var options = {};
        options.data = JSON.stringify(data);
        options.headers = {
            'Content-Type': 'application/json',
            'Data-Type': 'json',
            'Giving-Portal': 'true'
        };
        options.method = method;
        options.url = url;
        var request = Axios.default.request(options);
        return request;
    };
    // get: api/OnlineGiving/GivingOptions
    ApiGateway.RouteGetGivingOptions = function () { return "/api/OnlineGiving/GivingOptions"; };
    // get: api/OnlineGiving/DisplayCanadianSpelling
    ApiGateway.RouteGetDisplayCanadianSpelling = function () { return "/api/OnlineGiving/DisplayCanadianSpelling"; };
    // get: api/OnlineGiving/PaymentMethod
    ApiGateway.RoutePaymentMethod = function () { return "/api/OnlineGiving/PaymentMethod"; };
    // get: api/OnlineGiving/PublicToken?paymentMethodId=${encodeURIComponent(paymentMethodId)}
    ApiGateway.RoutePaymentPublicToken = function (paymentMethodId) { return "/api/OnlineGiving/PublicToken?paymentMethodId=" + encodeURIComponent(paymentMethodId); };
    // get: api/OnlineGiving/BusinessUnitHasCCPaymentMethods
    ApiGateway.RouteGetBusinessUnitHasCCPaymentMethods = function () { return "/api/OnlineGiving/BusinessUnitHasCCPaymentMethods"; };
    // get: api/OnlineGiving/SiteInfo
    ApiGateway.RouteGetSiteInfo = function () { return "/api/OnlineGiving/SiteInfo"; };
    // post: api/OnlineGiving/SubmitDonation
    ApiGateway.RouteSubmitDonation = function () { return "/api/OnlineGiving/SubmitDonation"; };
    return ApiGateway;
}());
exports.ApiGateway = ApiGateway;
var DonationDedicationType;
(function (DonationDedicationType) {
    DonationDedicationType[DonationDedicationType["NoDedication"] = 0] = "NoDedication";
    DonationDedicationType[DonationDedicationType["InMemoryOf"] = 1] = "InMemoryOf";
    DonationDedicationType[DonationDedicationType["InHonourOf"] = 2] = "InHonourOf";
})(DonationDedicationType = exports.DonationDedicationType || (exports.DonationDedicationType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["Cash"] = 1] = "Cash";
    PaymentType[PaymentType["Cheque"] = 2] = "Cheque";
    PaymentType[PaymentType["CreditCard"] = 3] = "CreditCard";
    PaymentType[PaymentType["ECheque"] = 4] = "ECheque";
    PaymentType[PaymentType["CreditTransfer"] = 5] = "CreditTransfer";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var ProcessorType;
(function (ProcessorType) {
    ProcessorType[ProcessorType["Bambora"] = 1] = "Bambora";
    ProcessorType[ProcessorType["Forte"] = 2] = "Forte";
    ProcessorType[ProcessorType["National"] = 3] = "National";
    ProcessorType[ProcessorType["Odin"] = 4] = "Odin";
})(ProcessorType = exports.ProcessorType || (exports.ProcessorType = {}));
var GatewayType;
(function (GatewayType) {
    GatewayType[GatewayType["CreditCard"] = 1] = "CreditCard";
    GatewayType[GatewayType["eCheck"] = 2] = "eCheck";
})(GatewayType = exports.GatewayType || (exports.GatewayType = {}));
var BackgroundType;
(function (BackgroundType) {
    BackgroundType[BackgroundType["SolidColor"] = 0] = "SolidColor";
    BackgroundType[BackgroundType["TiledImage"] = 1] = "TiledImage";
    BackgroundType[BackgroundType["FullSizedImage"] = 2] = "FullSizedImage";
})(BackgroundType = exports.BackgroundType || (exports.BackgroundType = {}));
var HeaderImageAlignment;
(function (HeaderImageAlignment) {
    HeaderImageAlignment[HeaderImageAlignment["Left"] = 0] = "Left";
    HeaderImageAlignment[HeaderImageAlignment["Right"] = 1] = "Right";
    HeaderImageAlignment[HeaderImageAlignment["Center"] = 2] = "Center";
    HeaderImageAlignment[HeaderImageAlignment["Justify"] = 3] = "Justify";
})(HeaderImageAlignment = exports.HeaderImageAlignment || (exports.HeaderImageAlignment = {}));
//}
